@use "@fukuri-admins/ui/layout" as *;

.content {
  display: flex;
  flex-direction: column;
  gap: spacing("16");
  width: 100%;
}

.howToUseSection {
  display: flex;
  flex-direction: column;
  gap: spacing("8");
  padding: spacing("16");
  background: background('Primary');
  border: 1px solid border('Secondary');
  border-radius: borderRadius('sm');
}

.howToUseTitleRow {
  display: flex;
  gap: spacing("8");
  align-items: center;
}

.howToUseTitle {
  @include typography('Jp/14_W6');
  color: text('Middle');
}

.guideLink {
  display: flex;
  gap: spacing("2");
  align-items: center;
  @include typography('Jp/14_W3');
  color: text('Link');
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.howToUseList {
  @include typography('Jp/14_W3');
  color: text('Middle');
  padding-left: spacing("16");
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: spacing("4");

  li {
    list-style-type: decimal;
  }
}

.templateButtons {
  display: flex;
  gap: spacing("4");
  align-items: center;
}


.templateSeparator {
  @include typography('Jp/12_W3');
  color: text('Low');
}

.registrationTypeSection {
  display: flex;
  flex-direction: column;
  gap: spacing("4");
}

.scheduledDateTimeWrapper {
  padding-left: 28px;
}
